module.exports = __webpack_public_path__ + "static/media/aurivo.82d6dd36.png";